import { defineMessages } from 'react-intl';

export default defineMessages({
  promotionalBannerEnhancedReturnsTitle: {
    description: 'Title for the enhanced returns promotional banner',
    defaultMessage: 'Upgrade your plan to support {marketplaceName} Return & Exchanges and gain access to other premium features',
    id: 'BS0NGN',
  },
  promotionalBannerStandardReturnsTitle: {
    description: 'Title for the standard returns promotional banner',
    // TODO: This message implies all standard returns was locked out
    defaultMessage: 'Upgrade your plan to support Standard Returns and gain access to other premium features',
    id: 'Qm/wGM',
  },
  promotionalBannerText: {
    description: 'Description for enhanced returns promotional banner',
    defaultMessage: 'This feature is not available on your existing subscription plan.',
    id: 'Nn+6pd',
  },
  upgradePlan: {
    description: 'button to upgrade the plan',
    defaultMessage: 'Upgrade',
    id: 'X6JpL5',
  },
  learnMore: {
    description: 'button to learn more about the feature',
    defaultMessage: 'Learn more',
    id: 'RmxmZb',
  },
});
